<template>
  <div class="tda-sources">
    <upload-content-area
      ref="uploadArea"
      v-model="uploadType"
      class="upload-content-area mb-0"
      :label="$t('essays.sourceMaterial')"
      :path="'source-materials'"
      :max-number-of-files="1000"
      :description="$t('essays.sourceMaterialDescription')"
      :accept-files="acceptedFileTypes"
      @input-files="files = $event"
      @input-text="content = $event"
      @file-added="$emit('file-added', $event)"
      @file-removed="$emit('file-removed', $event)"
    >
      <template #prepend-content>
        <div v-if="value.length > 0" class="mt-4 d-flex flex-column flex-gap-1">
          <div
            v-for="(file, index) in value"
            :key="file.id"
            class="file d-flex align-items-center flex-gap-1"
          >
            <div class="file-name">
              {{ file.name }}
            </div>
            <div
              class="file-status d-flex align-items-center ml-1"
              :class="file?.status?.includes('Error') && 'error'"
            >
              <eg-icon
                v-if="!file.status"
                class="mr-2"
                icon="check-circle"
                size="small"
              />
              {{ file.status ? file.status : $t("common.completed") }}
            </div>
            <div class="close ml-auto p-1">
              <a
                v-if="file.url"
                :href="file.url"
                :download="file.name"
                target="_blank"
              >
                <eg-icon
                  v-if="!file.status"
                  icon="read-only-view"
                  size="small"
                />
              </a>
            </div>
            <div class="close ml-auto p-1" @click="removeFile(index)">
              <eg-b-icon icon="x" />
            </div>
          </div>
        </div>
      </template>
    </upload-content-area>

    <div v-if="uploadType !== 'files'" class="mt-3">
      <eg-form-group :label="$t('essays.sourceName')" required>
        <div class="d-flex align-items-center">
          <eg-b-form-input
            v-model="name"
            :placeholder="$t('common.enterName')"
            type="text"
            name="name"
          />
          <eg-b-button
            :disabled="!(name.length > 0 && content.length > 0)"
            variant="info"
            class="ml-5"
            @click="addTextFile"
          >
            {{ $t("common.add") }}
          </eg-b-button>
        </div>
      </eg-form-group>
    </div>
  </div>
</template>

<script>
import EgFormGroup from "@/components/global/eg_form_group.vue";
import UploadContentArea from "@/components/dashboard/upload_content_area.vue";

export default {
  components: {
    EgFormGroup,
    UploadContentArea,
  },

  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      uploadType: "files",
      acceptedFileTypes: [
        ".txt",
        ".pdf",
        ".doc",
        ".docx",
        ".jpg",
        ".jpeg",
        ".png",
        ".pdf",
      ],
      files: [],
      content: "",
      name: "",
    };
  },

  watch: {
    files() {
      this.$emit("input", [
        ...this.value,
        ...this.files.map((file) => ({ ...file, status: "Ready to upload" })),
      ]);
    },
  },

  methods: {
    upload() {
      return this.$refs.uploadArea.upload();
    },

    addTextFile() {
      if (!this.name || this.content.trim() === "") {
        this.$showToastError(this.$t("essays.pleaseEnterNameAndContent"));

        return;
      }

      this.$emit("input", [
        ...this.value,
        {
          name: `${this.name}.txt`,
          content: this.content,
          status: "Ready to upload",
        },
      ]);
      this.content = "";
      this.$refs.uploadArea.textContent = "";
      this.name = "";
    },

    removeFile(index) {
      this.$emit(
        "input",
        this.value.slice(0, index).concat(this.value.slice(index + 1))
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.file {
  padding: 8px 12px;
  border: 1px solid var(--color-stroke-neutral-default);
  border-radius: 8px;

  .file-name {
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-grow: 1;
    font-weight: var(--typography-font-weight-fw-600);
  }

  .file-status {
    color: hsla(134, 61%, 41%, 1);
    font-size: var(--typography-font-size-fs-200);
  }

  .file-status.error {
    color: #dc3545;
  }
}

.close {
  cursor: pointer;
}
</style>
